import React from 'react';

import Editor from 'src/app/editor/Editor';

const EditorContainer = ({ params, location }) => (
  <Editor
    viewParams={params}
    query={location.query}
    shortcode={params.shortcode}
  />
);

export default EditorContainer;
